import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorHandler,NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layouts/header/header.component';
import { FooterComponent } from './layouts/footer/footer.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { NumberOnlyDirective } from './shared/directive/numberOnly.directive';
import { SharedModule } from './shared/shared.module';
import { PatientModule } from './pages/patient-details/patient-details.module';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { PlanModule } from './pages/plans/plans.module';
import { environment } from '../environments/environment';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { WriteToUsComponent } from './pages/write-to-us/write-to-us.component';
import { PayRecurringComponent } from './pages/pay-recurring/pay-recurring.component';
import { PendingOverdueComponent } from './pages/pending-overdue/pending-overdue.component';
import { CustomErrorHandlerService } from './services/custom-error-handler.service';
import { TwoDigitDecimaNumberDirective } from './shared/directive/two-decimal-number.directive';
import { NoDigitDecimaNumberDirective } from './shared/directive/no-decimal-number.directive';
import { PaymentPageComponent } from './pages/payment-page/payment-page.component';
import { GPayComponent } from './pages/g-pay/g-pay.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DecimaNumberDirective } from './shared/directive/decimal-number.directive';
import { Interceptor } from './interceptor/interceptor';
import {provideEnvironmentNgxMask } from 'ngx-mask'
import { ModalBaseComponent } from './pages/modal-base/modal-base.component';
import { PreApprovalComponent } from './pages/pre-approval/pre-approval.component';
import { OnlyNumberDirective } from './shared/directive/only-number.directive';
import { io, Socket } from 'socket.io-client';
import { MainService } from './services/main-service.service';
import { IntercomModule } from '@supy-io/ngx-intercom';
import { PractinaModule } from './pages/practina/practina.module';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        NotFoundComponent,
        WriteToUsComponent,
        // PayRecurringComponent,
        PendingOverdueComponent,
        TwoDigitDecimaNumberDirective,
        NoDigitDecimaNumberDirective,
        PaymentPageComponent,
        GPayComponent,
        ModalBaseComponent,
        PreApprovalComponent,
        OnlyNumberDirective,
        NumberOnlyDirective,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        // SocketIoModule.forRoot(config),
        // AngularFontAwesomeModule,
        SharedModule,
        PatientModule,
        PlanModule,
        PractinaModule,
        ModalModule.forRoot(),
        ToastrModule.forRoot(
            {
                positionClass :'toast-bottom-center',
            }
        ),
        
        IntercomModule.forRoot({
            appId: environment.intercom_id,
            updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
        }),
        DecimaNumberDirective,
        RecaptchaModule,
    ],
    exports: [],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    // tslint:disable-next-line:max-line-length
    providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: Interceptor,
            multi: true
        },
        NumberOnlyDirective,
        TwoDigitDecimaNumberDirective,
        NoDigitDecimaNumberDirective,
        // ToasterService,
        MainService,
        provideEnvironmentNgxMask(),
        { provide: ErrorHandler, useClass: CustomErrorHandlerService },
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.recaptchaSiteKey,
            } as RecaptchaSettings,
        },
        {
            provide: Socket,
            useFactory: () => io(environment.socketBaseUrl, {path: 'customer/socket.io'}), // Provide the socket instance
          },
        // { provide: ToastrService, useClass: ToastrService },
        // { provide: ToastNoAnimation, useClass: ToastNoAnimation }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
